/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Route, RouteComponentProps } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { Text } from 'hocs/localization'
import { SUBSCRIPTION_PLAN_TYPE } from 'constants/subscription'
import ProfileContent from 'apps/ProfileContent'
import ButtonWithIcon from 'apps/ButtonWithIcon'
import Button from 'elements/Button'
import contract from 'assets/images/contract.png'
import mo2mo from 'assets/images/mo2mo.png'
import { toCurrency } from 'utils/price'
import { getPrintedDateLocal } from 'utils/date'
import * as styles from './PlanRenewal.scss'

const cx = classNames.bind(styles)

interface IProps extends RouteComponentProps {
  t: Text
  handleSubmit: any,
  acceptTerms: () => void,
  plans: any[],
  currentUserPlanImageUri: string,
  activePlanId: string,
  currentUserPlanName: string,
  contractExpirationDate: string,
  onShowTerms: (planId: string) => Promise<{}>,
  onSelectChangePlan: () => void
}

interface IState {
  selectedPlanId: string,
  isUserAbleToOpenProfile: boolean,
  isButtonDisabled: boolean,
  isSubmitting: boolean,
}

class PlanRenewal extends React.Component<IProps, IState> {
  public state = {
    selectedPlanId: this.props.activePlanId,
    isButtonDisabled: !this.props.plans.some(x => x.id == this.props.activePlanId),
    isSubmitting: false,
  }

  private onChoosePlan = planId => {
    this.setState({
      selectedPlanId: planId,
    })

    this.state.isButtonDisabled = false
  }

  private onReturnBack = () => {
    this.props.history.push(ROUTES.profile.view)
  }

  private onSubmit = () => {
    const { selectedPlanId } = this.state
    this.setState({
      isSubmitting: true,
    })

    return this.props.onShowTerms(selectedPlanId)
  }

  private onSubmitChangePlan = () => {
    this.setState({
      isSubmitting: true,
    })

    return this.props.onSelectChangePlan()
  }

  public render () {
    const {
      t,
      plans,
      activePlanId,
      currentUserPlanImageUri,
      currentUserPlanName,
      contractExpirationDate,
    } = this.props
    const {
      selectedPlanId,
      isSubmitting,
      isButtonDisabled,
    } = this.state

    return (
      <ProfileContent>
        <div className='row'>
          <div className={cx('col-md-12', 'text-center')}>
            <div className={styles.title}>
              <h2>{t('title')}</h2>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className={cx('col-md-12', 'planDescription')}>
            <div className={styles.planImg}>
              <img src={currentUserPlanImageUri} alt={currentUserPlanName} />
            </div>
            <div>
              <div className={styles.currentPlanText}>Current plan: {currentUserPlanName}</div>
              <div>Plan expires: {getPrintedDateLocal(contractExpirationDate)}</div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className={cx('col-md-12', 'text-center')}>
            <div className={styles.subTitle}>
            <h2>{plans.length > 0 ? t('subTitle') : t('renewalOptionsNotAvailable')}</h2>
              {plans.length == 0 && (
                <h2>{t('renewalOptionsChoseNewPlan')}</h2>
              )}
            </div>
          </div>
        </div>

        <div className={cx('row', styles.topSpace50, styles.plansContainer)}>
          {plans.map(plan => (
            <div key={plan.id} className={cx('col-lg-4', 'col-md-4', 'col-sm-12', styles.plan)}>
              <div
                className={cx(
                  plan.id === selectedPlanId && styles.changePlan,
                  styles.planContent,
                  {
                    active: plan.id === selectedPlanId,
                  },
                )}
                >
                <div className={styles.image}>
                  <img src={plan.subscriptionPlanCategoryType === SUBSCRIPTION_PLAN_TYPE.contract
                    ? contract : mo2mo} alt={plan.name} />
                </div>
                <div className={styles.office}>
                  <h2>
                    {plan.subscriptionPlanCategoryType === SUBSCRIPTION_PLAN_TYPE.contract ? '2-year Contract' : 'Month-to-month'}
                  </h2>
                  <h4 className={cx({ withFee: !!plan.activationFee })}>
                    {plan.subscriptionPlanCategoryType === SUBSCRIPTION_PLAN_TYPE.monthToMonth && (
                      <div className={styles.upTo}>{t('upTo')}</div>
                    )}
                    {t('price', { price: toCurrency(plan.price) })}
                    {!!plan.activationFee && (
                      <div className={styles.fee}>
                        {t('activationFee', { activationFee: toCurrency(plan.activationFee) })}
                      </div>
                    )}
                    <div className={styles.fee}>{t('taxes')}</div>
{/*                     <div className={styles.fee}>{t('taxes')}</div> */}
                  </h4>

                  <div className={styles.selectButtonWrapper}>
                    <Button
                      fluid
                      styleType='primary'
                      onClick={() => { this.onChoosePlan(plan.id) } }>
                      {plan.id === selectedPlanId ? t('selectedButton') : t('selectButton')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={cx(styles.saveChange, styles.topSpace50)}>
          <div className={styles.backLink}>
            <ButtonWithIcon
              styleType='noStyle'
              onClick={this.onReturnBack}>
              {t('back')}
            </ButtonWithIcon>
          </div>
          <div className={styles.buttonWrapper}>
            {plans.length > 0 &&
            <Button
              fluid
              disabled={isButtonDisabled || isSubmitting}
              styleType='primary'
              onClick={this.onSubmit}
            >
              {isSubmitting ? t('submitButtonSubmitting') : t('submitButton')}
            </Button>
            }
             {plans.length == 0 &&
            <Button
              fluid
              disabled={isSubmitting}
              styleType='primary'
              onClick={this.onSubmitChangePlan}
            >
              {isSubmitting ? t('submitButtonSubmitting') : t('choseNewPlanButton')}
            </Button>
            }
          </div>
        </div>
      </ProfileContent>
    )
  }
}

export default PlanRenewal
